import React from 'react';

import { RatingLetterIcon } from 'components';
import { styled } from 'core/styles';
import { Rating } from 'domain/types';

type HealthWidgetProps = {
  title: string;
  description: React.ReactNode;
  rating: Rating;
  children: React.ReactNode;
};

export function HealthWidget(props: HealthWidgetProps) {
  const { title, description, rating } = props;
  return (
    <Root>
      <HealthContent>
        <HealthTitle>{title}</HealthTitle>
        {description && <HealthDescription>{description}</HealthDescription>}
        <HealthRating>
          <RatingLetterIcon rating={rating} />
        </HealthRating>
      </HealthContent>
      <HealthChart>{props.children}</HealthChart>
    </Root>
  );
}

const Root = styled('div')(() => ({
  minHeight: 168,
  display: 'flex',
  justifyContent: 'space-between',
  gap: 8,
  fontSize: 12,
  letterSpacing: 0.25,
}));
const HealthContent = styled('div')(() => ({
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
}));
const HealthTitle = styled('div')(() => ({
  marginBottom: 8,
}));
const HealthDescription = styled('div')(() => ({
  marginBottom: 16,
}));
const HealthRating = styled('div')(() => ({
  fontSize: 46,
  marginTop: 'auto',
}));
const HealthChart = styled('div')(() => ({
  width: '50%',
}));
